"use client";

import {
  CustomerConfirmSignUpStepForm,
  type CustomerConfirmSignUpStepFormProps,
} from "@/components/auth/customer-confirm-signup-step-form";

type CustomerLoginCodeStepFormProps = Omit<CustomerConfirmSignUpStepFormProps, "codeLength">;

/**
 * Login-step variant: the backend's email OTP issues 8 digits, unlike the
 * 6-digit signup confirmation code — same grid/logic, only length and copy differ.
 */
export function CustomerLoginCodeStepForm(props: CustomerLoginCodeStepFormProps) {
  return <CustomerConfirmSignUpStepForm {...props} codeLength={8} />;
}
